import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { WireProductDetails } from '@idealsupply/products-api-angular-client';
import { AuthenticationStore, IdealUser } from 'authentication-data';
import { ItemComponentStore, ItemId } from 'products-data';
import { ItemResultsComponent } from '../../../../../item';
import {
  ProductSectionComponent,
  ProductIdLabelComponent,
  ProductShortDescriptionComponent,
  ProductVendorLinkComponent,
} from '../../../../common';
import { RenderInProductDetailsViewDirective } from '../../../../layouts/product-detail/product-detail-layout/render-targets/render-in-product-details.directive';
import { ProductDetailLayoutComponentsProviderComponentBase } from '../../../../layouts/product-detail/ProductDetailLayoutComponentsProviderComponentBase';

@Component({
  selector: 'ideal-wire-cut-product-detail-layout-components-provider',
  imports: [
    RenderInProductDetailsViewDirective,
    ItemResultsComponent,
    ProductIdLabelComponent,
    ProductShortDescriptionComponent,
    ProductVendorLinkComponent,
  ],
  standalone: true,
  templateUrl: './wire-cut-product-detail-layout-components-provider.component.html',
  styleUrl: './wire-cut-product-detail-layout-components-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ItemComponentStore],
})
export class WireCutProductDetailLayoutComponentsProviderComponent extends ProductDetailLayoutComponentsProviderComponentBase {
  protected readonly itemStore = inject(ItemComponentStore);
  private readonly _auth = inject(AuthenticationStore);

  /**
   * Custom lengths are only offered to users with an approved customer account (at least one
   * customer number on the user). Anonymous visitors and users who only have the default cash
   * account never get the custom-items list rendered. Which account they then order with is not
   * restricted.
   */
  protected readonly canOrderCustomLengths = computed(() => (this._auth.asType(IdealUser)?.customerNumbers.length ?? 0) > 0);
  protected readonly productDetails = computed(() => this.productStore.productDetails() as WireProductDetails | undefined);

  protected readonly itemsReady = computed(() => !this.itemStore.productItems.loading() && !!this.itemStore.productItems());
  protected readonly hasCustom = computed(() => this.itemsReady() && this.itemStore.productItems().some((i) => i.id.options.has('Z')));

  protected readonly specSheetUrl = computed(() => this.productDetails()?.specSheetUrl ?? '');

  protected readonly longDescription = computed(() => this.productDetails()?.longDescription ?? '');

  protected customIdsFilter(id: ItemId): boolean {
    console.log('customIdsFilter', id, id.options.has('Z'));
    return id.options.has('Z');
  }

  protected nonCustomIdsFilter(id: ItemId): boolean {
    return !id.options.has('Z');
  }

  constructor() {
    super();
    effect(() => this.itemStore.selectProductItemsById(this.productId()));
  }
}
